<div *ngIf="quarter !== 'q4'" class="title"><span class="pink">{{ quarter | titlecase }}</span>&nbsp;Results</div>
<div *ngIf="quarter === 'q4'" class="title"><span class="pink">Final</span>&nbsp;Results</div>
<ng-content></ng-content>
